module.exports = __webpack_public_path__ + "static/media/skillCharm.12308111.png";